import { on } from 'delegated-events';
import type { Context } from '@nuxt/types';

/**
 * @description Track clicks on elements with `anal-click-name` attribute.
 * @example
 * ```html
 * <BravadoButtonV3 anal-click-name="war-room__see-all-deals__click" />
 * ```
 */
export const trackClickElementByName = ({ app }: Context) => {
  on('click', '[anal-click-name]', function handleOnClick() {
    app.$analytics.logEvent(this.getAttribute('anal-click-name'));
  });
};
